<template>
  <div id="monacoEditor" ref="editor" v-show="themeInitialized"></div>
</template>

<style lang="scss" scoped>
@charset "utf-8";

#monacoEditor {
  height: 100%;
}
</style>

<script>
// @flow
import * as monaco from 'monaco-editor/esm/vs/editor/editor.api' // needs to be imported this way in order to include only subset of languages
import { mapGetters } from 'vuex'

export default {
  name: 'MonacoDiffEditor',
  data() {
    return {
      editor: null,
      options: {
        language: 'javascript',
        tabSize: 2,
        wordBasedSuggestions: false,
        glyphMargin: false,
        quickSuggestions: false,
        automaticLayout: true,
        dragAndDrop: true,
        enableSplitViewResizing: false,
        renderControlCharacters: true,
        renderIndicators: false
      },
      themeInitialized: false
    }
  },

  props: {
    originalValue: {
      type: String,
      default: () => ''
    },
    modifiedValue: {
      type: String,
      default: () => ''
    }
  },

  computed: {
    ...mapGetters(['userPrefsInitialized'])
  },

  methods: {
    setUpEditor() {
      this.setUpCompilerOptions()

      this.editor = monaco.editor.createDiffEditor(this.$el, {
        readOnly: true,
        ...this.options
      })

      this.bindNewModels(this.originalValue, this.modifiedValue)
    },

    setUpCompilerOptions() {
      monaco.languages.typescript.javascriptDefaults.setCompilerOptions({
        target: monaco.languages.typescript.ScriptTarget.ES5,
        noLib: true,
        allowNonTsExtensions: true
      })

      monaco.languages.typescript.typescriptDefaults.setCompilerOptions({
        noLib: true,
        allowNonTsExtensions: true
      })
    },

    bindNewModels(original, modified) {
      let originalModel = monaco.editor.createModel(original, 'text/javascript')
      let modifiedModel = monaco.editor.createModel(modified, 'text/javascript')

      if (original != null && modified != null) {
        this.editor.setModel({
          original: originalModel,
          modified: modifiedModel
        })
      }
    },

    triggerLayout() {
      setTimeout(() => {
        this.editor.layout()
      }, 200)
    },

    renderIfReady() {
      if (this.userPrefsInitialized) {
        this.themeInitialized = true
        this.triggerLayout()
      }
    }
  },

  mounted() {
    this.setUpEditor()
    this.renderIfReady()
  },

  watch: {
    originalValue(newVal) {
      if (newVal !== this.editor.getOriginalEditor().getValue()) {
        this.bindNewModels(newVal, this.modifiedValue)
      }
    },
    modifiedValue(newVal) {
      if (newVal !== this.editor.getModifiedEditor().getValue()) {
        this.bindNewModels(this.originalValue, newVal)
      }
    },
    userPrefsInitialized() {
      this.renderIfReady()
    }
  }
}
</script>
